import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IGetDraftJobPostApiResponse } from '../types';

export const getDraftJobPost = async (id: string): Promise<IGetDraftJobPostApiResponse> => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<IGetDraftJobPostApiResponse>(
    `/posting-service/postings/${id}`,
    {
      headers,
    },
  );

  return response.data;
};
